import SubObjectCache from './SubObjectCache';

/**
 * @typedef {Object} cacheSubObject
 * @property {String} rootKey
 * @property {String} key
 */

export const rootKey = 'ATC_USER';
export const key = 'leadProfile';

/**
 * Handles storing and caching email form contact information submitted by a user
 * @module LeadProfileCache
 */
const LeadProfileCache = /* #__PURE__*/(() => new SubObjectCache({
  rootKey,
  key
}))();
export default LeadProfileCache;